import React from 'react';
import '../../styles/components/project-card.scss';
import { fmt } from '../../utils/common';
import { OMR } from './icons';

class ProjectCard extends React.Component {
  render() {
    const { icon: Icon, className, title, value, valueLabel, amount, onClick, selected } = this.props;
    const cardClass = `project-card ${className} ${selected ? 'selected' : ''}`;

    return (
      <div
        className={cardClass}
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
          }
        }}
      >
        <div className="project-card-body">
          <div className={`project-card-icon ${className}`}>
            <Icon size={24} />
          </div>
          <div className="project-card-text">
            <div className="project-header">{title}</div>

            {amount !== undefined && (
              <div className="project-amount">
                {fmt(amount)} <OMR size={11} />
              </div>
            )}
            <div className="project-value">
              {value} {valueLabel}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectCard;
